<template>
  <div>
    <!-- 중앙모달 -->
    <div :class="{ modal: true, selectLanguage: true, center: true, on: true }">
      <header>
        <img
          src="@/assets/images/logo.jpeg"
          style="width: 40px"
          alt="novaLab"
        />
        <div class="flex">
          <h2>Select Language</h2>
          <button
            type="button"
            class="material-icons btnClose"
            @click="closeModal"
          >
            close
          </button>
        </div>
      </header>
      <section class="inner">
        <fieldset>
          <legend>언어선택</legend>
          <ul class="language-element">
            <li v-for="(data, i) in langList" :key="i" @click="data.func">
              <b :class="{ red: data.value == currentLang ? true : false }">{{
                data.text
              }}</b>
            </li>
            <!-- <li>
              <b :class="{ blue: lang == '1' ? true : false }">English</b>
            </li>
            <li>
              <b :class="{ blue: lang == '2' ? true : false }">中文</b>
            </li>
            <li>
              <b :class="{ blue: lang == '3' ? true : false }">日本</b>
            </li>
            <li>
              <b :class="{ blue: lang == '4' ? true : false }">Português</b>
            </li>
            <li>
              <b :class="{ blue: lang == '5' ? true : false }">Español</b>
            </li> -->
          </ul>
          <!-- <div class="btns">
            <button type="submit" class="on">확인</button>
          </div> -->
        </fieldset>
      </section>
    </div>
  </div>
</template>
<script>
// import _ from "lodash";
// import { createConfirmAuth } from "@/api/member";
// import { createLogin } from "@/api/member";
import { mapState } from "vuex";
import { eventBus } from "@/main";
import lang from "@/mixins/lang";
import { timer } from "@/mixins/timer";
export default {
  mixins: [timer, lang],
  data() {
    return {
      visible: false,
      message: "정상적으로 처리 되었습니다.",
      authCode: [],
      authCodeSendIdx: null,
      showSnackbar: false,
      resetAlert: false,
      count: null,
    };
  },
  created() {
    this.resetAuthNo();
  },
  mounted() {
    this.$refs.input.focus();
    this.timer();
  },
  computed: {
    ...mapState(["currentLang"]),
  },
  methods: {
    closeModal() {
      eventBus.$emit("closeModal", true);
    },
  },
};
</script>
<style lang="scss" scoped>
header {
  .flex {
    display: flex;
    justify-content: space-evenly;
    font-weight: bold;
  }
}
</style>
